<template>
  <div>
    <div class="snackbarPersonalize" v-if="isOffline">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    snackbar: true,
    text: 'Su conexión actualmente es inestable, su experiencia en la plataforma se puede ver afectada.',
  }),
  computed: {
    networkStatus() {
      return this.isOffline ? 'My network is fine' : 'I am offline';
    },
  },
};
</script>

<style>
.snackbarPersonalize{
    opacity: 0.5;
    text-align: center;
    background-color: rgb(50, 50, 50);
    width: 420px;
    height: 50px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    color: white;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
    overflow: none;
}
</style>


// WEBPACK FOOTER //
// src/components/global/NotConnection.vue